import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "box-input escape-confirm" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "txt-danger txt-required"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "*", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "input is_readonly"
}
const _hoisted_8 = ["value", "type", "placeholder", "autocomplete"]
const _hoisted_9 = ["value", "type", "placeholder", "autocomplete", "min"]
const _hoisted_10 = {
  key: 3,
  class: "is-password"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 6,
  class: "tel-prefix"
}
const _hoisted_16 = {
  key: 1,
  class: "mb0 txt-danger font14 mt3"
}

export function render(_ctx, _cache) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.updatedLabel,
          class: "txt-ellipsis bold"
        }, [
          _createTextVNode(_toDisplayString(_ctx.updatedLabel && _ctx.$t(_ctx.updatedLabel)) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.type === 'date')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.isError ? 'outline-error':'', "row"])
          }, [
            (_ctx.readonly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$helper?.formatDate(_ctx.dateValue)), 1))
              : (_openBlock(), _createBlock(_component_VueDatePicker, {
                  key: 1,
                  modelValue: _ctx.dateValue,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = $event => ((_ctx.dateValue) = $event)),
                    _ctx.dateOnChange
                  ],
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                  "min-date": _ctx.minDate ? new Date(_ctx.minDate || '') : '',
                  dark: _ctx.$store?.state?.appMode === 'dark-mode' ? true : false,
                  placeholder: _ctx.placeholder ? _ctx.$t(_ctx.placeholder) : _ctx.dateFormat,
                  format: _ctx.dateFormat
                }, null, 8, ["modelValue", "onUpdate:modelValue", "min-date", "dark", "placeholder", "format"]))
          ], 2))
        : (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              value: _ctx.value,
              type: _ctx.eye ? (_ctx.isTypeString ? 'text' : 'password') : 'text',
              placeholder: _ctx.placeholder ? _ctx.$t(_ctx.placeholder) : 'N/A',
              class: _normalizeClass([[_ctx.className, { 'outline-danger': _ctx.isError, 'pl60': _ctx.type === 'tel', 'pl45': _ctx.searchable && _ctx.left, 'pr55': _ctx.searchable && !_ctx.left }], "input is_readonly"]),
              ref: _ctx.refIds,
              autocomplete: _ctx.autocompleteValue,
              readonly: ""
            }, null, 10, _hoisted_8))
          : (_openBlock(), _createElementBlock("input", {
              key: 2,
              value: _ctx.value,
              onKeyup: [
                _cache[2] || (_cache[2] = _withKeys((...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"])),
                _cache[3] || (_cache[3] = $event => (_ctx.onKeypress($event)))
              ],
              onKeypress: _cache[4] || (_cache[4] = $event => (_ctx.onKeypress($event))),
              onChange: _cache[5] || (_cache[5] = $event => (_ctx.onKeypress($event))),
              onInput: _cache[6] || (_cache[6] = $event => (_ctx.onEmits($event))),
              onKeydown: _cache[7] || (_cache[7] = (...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args))),
              type: _ctx.eye ? (_ctx.isTypeString ? 'text' : 'password') : (_ctx.type === 'date' || _ctx.type === 'timestamp') ? _ctx.type : 'text',
              placeholder: _ctx.placeholder ? _ctx.$t(_ctx.placeholder) : 'N/A',
              class: _normalizeClass([[_ctx.className, { 'outline-danger': _ctx.isError, 'pl60': _ctx.type === 'tel', 'pl45': _ctx.searchable && _ctx.left, 'pr55': _ctx.searchable && !_ctx.left }], "input"]),
              ref: _ctx.refIds,
              autocomplete: _ctx.autocompleteValue,
              min: _ctx.minDate || ''
            }, null, 42, _hoisted_9)),
      (_ctx.eye)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.isTypeString)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  onClick: _cache[8] || (_cache[8] = $event => (_ctx.isTypeString = !_ctx.isTypeString)),
                  src: require('@/assets/icons/sidebars/eye.svg')
                }, null, 8, _hoisted_11))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  onClick: _cache[9] || (_cache[9] = $event => (_ctx.isTypeString = !_ctx.isTypeString)),
                  src: require('@/assets/icons/sidebars/close-eye.svg')
                }, null, 8, _hoisted_12))
          ]))
        : _createCommentVNode("", true),
      (_ctx.searchable && _ctx.left)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.onEnter && _ctx.onEnter(...args))),
            class: "c-input-btn-search"
          }, [
            _createElementVNode("img", {
              src: require('@/assets/icons/sidebars/search.svg'),
              alt: ""
            }, null, 8, _hoisted_13)
          ]))
        : _createCommentVNode("", true),
      (_ctx.searchable && !_ctx.left)
        ? (_openBlock(), _createElementBlock("div", {
            key: 5,
            onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.onEnter && _ctx.onEnter(...args))),
            class: "c-input-btn-search-right"
          }, [
            _createElementVNode("img", {
              src: require('@/assets/icons/sidebars/white-search.svg'),
              style: {"filter":"none","opacity":"1"},
              alt: ""
            }, null, 8, _hoisted_14)
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'tel')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, "+855"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isError && _ctx.showError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.isError)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}